export const environment = {
  gigyaApiKey: '4_YxyopV0TUPBCy9Rwpv8QMg',
  siteTitle: 'Central Login Page',
  localStorageLangKey: 'CLP_lang',
  localStorageAlertDisposedKey: 'CLP_disposed_alert',
  sessionStorageToken: 'token',
  production: false,
  development: true,
  preproduction: false,
  showLogs: true,
  mocks: false,
  urlPolPriv: `https://clubclientedev.aena-aeropuertos.es/AenaClub/`,
  apiKeyCookies:
    'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhNmE2ZDA3YS1kYjhiLTRmNTAtOWU3Ny01N2EzOGNiZDk1YTAiLCJpYXQiOjE2NDcwMDA5MjEsIm5iZiI6MTY0NzAwMDkyMSwianRpIjoiZDFiZTAzMzItYjQ3NS00OTA2LTk0NzUtNGU4ZmE4ZjcxZjUyIiwiZXhwIjoxODA0NjgwOTIxfQ.ABWWsL-GxLHRSXQlfn4pCT1tYyeOGhkG5ggjstVkZ_M',
  cookiesPlatformToken: {
    es: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhNmE2ZDA3YS1kYjhiLTRmNTAtOWU3Ny01N2EzOGNiZDk1YTAiLCJpYXQiOjE2NzY4ODUwMjEsIm5iZiI6MTY3Njg4NTAyMSwianRpIjoiYTA5NTI2ZjYtMzRiZi00Y2Y2LTg0YzYtNGQzOTYxNDVkNGJhIiwicGlkIjoiNjQ3ODE0NDMtYTYxNC00NDM2LThhZjMtNDc2YmI2NmU4MzM5In0.xegvc3vW0TC0Xw8zKRqiEkw3I2iG9EFsRqo1PylTChM',
    en: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhNmE2ZDA3YS1kYjhiLTRmNTAtOWU3Ny01N2EzOGNiZDk1YTAiLCJpYXQiOjE2NzY4ODUwODMsIm5iZiI6MTY3Njg4NTA4MywianRpIjoiYmY3ZjUzZDMtYWNhMS00ZmRjLWIwOGItMDI2YzVkNDI1ZWYyIiwicGlkIjoiMDcyOWZkMmMtZGY5Ny00YzdjLWE4MWUtYTU5MGE2MmExMTQyIn0.uOthmYFCVOMZRdNPbqaEsVoaOtIPDtm99L6ACbP98aY',
  },
  defaultSSO_Params: {
    authFlow: 'redirect',
    redirectURL: 'https://clubclientedev.aena-aeropuertos.es/',
  },
  raasImports: {
    css: 'https://des-usuarios.aena.es/raas/gigya-raas.css',
    js: 'https://des-usuarios.aena.es/raas/gigya-raas.js',
  },
};
